import { bookingInquiryApis } from '@apis/bookingInquiryApis';
import { useMutation } from '@hooks/useMutation';
import { useQueryClient } from '@tanstack/react-query';
import { CodeError } from '@utils/errors';

export const useBookingInquiryViewerCreate = (d2d_no: string) => {
  const queryClient = useQueryClient();
  return useMutation(
    async (viewer: string) => {
      const response = await bookingInquiryApis.post('/booking-inquiry/can-view/', {
        body: { d2d_no, viewer },
      });
      if (response[400]) {
        return new CodeError(response[400].code);
      }
      if (response[201]) {
        return;
      }

      throw new Error('BookingInquiryViewerCreate');
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([`/booking-inquiry/${d2d_no}/`]);
      },
    },
  );
};
